import { ReactElement, Suspense } from 'react'
import { RouterProvider, createBrowserRouter } from 'react-router-dom'
import routes from './routes'
import Image from 'components/common/Image'

import logo from 'logo.svg'
import tselLogo from '../assets/images/tsel-logo.png'

const router = createBrowserRouter(routes)

const Router = (): ReactElement => {
    const isUserRoute = window.location.pathname.startsWith('/user')

    return (
        <Suspense
            fallback={
                <div
                    style={{
                        minHeight: '100vh',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <Image
                        src={isUserRoute ? tselLogo : logo}
                        className="pointer-events-none animation-shake"
                        alt="logo"
                        height="100px"
                        width="100px"
                    />
                </div>
            }
        >
            <RouterProvider router={router} />
        </Suspense>
    )
}

export default Router
